import { Grid } from "@mui/material";
import React, { useEffect } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import Inventory2Icon from '@mui/icons-material/Inventory2';
import { labelStore } from "../../../FrontEnd/UpdateChange/LableStore";


export const BalanceList: React.FC = () => {
  const navigate = useNavigate();

  // Header
   useEffect(() => {
  updateMainHeader("Inventory");
  labelStore.updateIcon(<Inventory2Icon sx={{ fontSize: 32 }} />);
}, []);

  // Breadcrumbs
  breadCrumbsStore.updateBreadCrumbs([
    { "Stock Balance": "/stock-balance/list" },
  ]);

  const source = {
    url: "stock-balance/list",  
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
    type: 'GET' as const 
  };
 
  const columns: IColumns[] = [
    { header: "Date", fieldName: "VerifiedDate" ,type:"date"},
    { header: "Item Name", fieldName: "ItemName" },
    { header: "Warehouse", fieldName: "WarehouseName" },
    { header: "Quantity", fieldName: "Quantity" },
    { header: "Created Date", fieldName: "CreatedDate" ,type:"date"},
   
  ];

 

  // const handleClick = () => {
  //   navigate("/verification");
  // };

  return (
    <Grid p={3}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="stockbalanceGrid"
            title="Stock Balance"
            headerType="modern"
            columns={columns}
            source={source}
            rowsPerPageCount={10}
            searchBox={{ searchMode: "query" }}
            // addButton={{ label: "Add New Item", color: "secondary" }}
            // onAddButtonClick={handleClick}
            
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke",
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};